// reducers/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
import { logout } from '../actions/auth.actions';
import globalSpinnerReducer from '../slicers/globalSpinner.slicer';
import menuReducer from '../slicers/menu.slicers';
import snackbarAlertReducer from '../slicers/snackbarAlert.slicer';

const appReducer = combineReducers({
  menu: menuReducer,
  globalSpinner: globalSpinnerReducer,
  snackbarAlert: snackbarAlertReducer
});

const rootReducer = (state: any, action: any) => {
  if (logout.match(action)) {
    state = undefined; // Reseta o estado
  }
  return appReducer(state, action);
};

export default rootReducer;
